<script>
import CarouselComponent from "@/views/components/CarouselComponent.vue";
import TriviaService from "@/api/services/triviaService";
import { mapState, mapMutations } from "vuex";

export default {
  components: {
    CarouselComponent
  },

  data() {
    return {
      leaderboardArray: [],
      userPositionArray: []
    }
  },

  computed: {
    ...mapState(['user', 'productId', 'token', 'brandConfig', 'isLoading', 'isFreeUser','currentSeason'])
  },

  methods: {
    ...mapMutations(['setIsLoading']),

    getAvatar(avatar) {
      try {
        return require(`@/assets/profile/avatar-${avatar}-unselected.png`)
      } catch (_error) {
        return require(`@/assets/profile/avatar-skeleton-unselected.png`)
      }
    },

    checkUsername(username) {
      return username || '(No username)';
    }
  },

  async beforeMount() {
    this.setIsLoading(true);

    if (!this.user || !this.user.msisdn) {
      console.error('User data not available');
      this.setIsLoading(false);

      return;
    }

    try {
      const recordsets = this.brandConfig?.newIntegration
          ? await TriviaService.getLeaderboardV2(this.token, this.user.serviceId, this.productId)
          : await TriviaService.getLeaderboard(this.user.msisdn, this.user.serviceId, this.productId);

      this.leaderboardArray = recordsets?.[0] || [];
      this.userPositionArray = recordsets?.[1] || [];
    } catch (error) {
      console.error('Error fetching leaderboard:', error);
    }

    this.setIsLoading(false);
  }
}
</script>

<template>
  <div class="container">
    <div class="row">
      <div class="col-12">
        <img :src="isFreeUser ? require('@/assets/logos/logo-free.png') : require('@/assets/logos/logo-vip.png')"  class="col-4 mt-2" alt="logo" />
      </div>

      <div class="d-flex flex-column justify-content-center align-items-center col-12 mb-4 mt-4">
        <CarouselComponent :season="currentSeason" />
      </div>

      <div class="text-center heading">Weekly Leaderboard</div>
      <div class="text-center normalText">Challenge, conquer, and rule the rhythm</div>
      <div class="text-center normalText">as the weekly maestro</div>

      <div v-if="!isLoading" class="d-flex justify-content-center align-items-center position-relative col-12">
        <img src="@/assets/leaderboard/leaderboard-bg-container1.png" alt="" class="col-11 mt-3" />

        <div v-if="leaderboardArray[1]" class="d-flex flex-column position-absolute col-3 secondPlace">
          <img :src="getAvatar(leaderboardArray[1].AvatarLocation)" alt="leaderboard profile" class="col-12">
          <div class="bold mt-3 text-center col-12">2nd</div>
          <div class="textNorm text-center mt-1 col-12">{{ checkUsername(leaderboardArray[1].Username) }}</div>
          <div class="bold text-center col-12">{{ leaderboardArray[1].Coins }} coins</div>
        </div>

        <div v-if="leaderboardArray[0]" class="d-flex flex-column position-absolute col-3 firstPlace">
          <img :src="getAvatar(leaderboardArray[0].AvatarLocation)" alt="leaderboard profile" class="col-12">
          <div class="bold text-center mt-4 col-12">1ST</div>
          <div class="textNorm text-center mt-1 col-12">{{ checkUsername(leaderboardArray[0].Username) }}</div>
          <div class="bold text-center col-12">{{ leaderboardArray[0].Coins }} coins</div>
        </div>

        <div v-if="leaderboardArray[2]" class="d-flex flex-column position-absolute col-3 thirdPlace">
          <img :src="getAvatar(leaderboardArray[2].AvatarLocation)" alt="leaderboard profile" class="col-12">
          <div class="bold mt-3 text-center col-12">3rd</div>
          <div class="textNorm text-center mt-1 col-12">{{ checkUsername(leaderboardArray[2].Username) }}</div>
          <div class="bold text-center col-12">{{ leaderboardArray[2].Coins }} coins</div>
        </div>

        <div v-if="userPositionArray.length >= 0" class="text-center mt-5 p-3 position-absolute positionButton col-10">
  <span v-if="userPositionArray[0]?.Coins > 0 && userPositionArray[0]?.RankNumber">
    Your Position: {{ userPositionArray[0]?.RankNumber }}
  </span>
          <span v-else>
    Play to rank up
  </span>
        </div>

        <div class="d-flex justify-content-between position-absolute players col-9">
          <div class="textNorm">Place</div>
          <div class="textNorm">Player name</div>
          <div class="textNorm">Coins</div>
        </div>

        <div class="position-absolute scrollable-leaderboard mt-1 col-10">
          <div v-for="(user, index) in leaderboardArray.slice(0, 50)" :key="index"
               class="d-flex justify-content-between playerRowItem">
            <div class="playerRow col-3">{{ user.RankNumber }}</div>
            <div class="playerRow col-3">{{ checkUsername(user.Username) }}</div>
            <div class="playerRow col-3 text-center">{{ user.Coins }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.heading{
  font-family: "Clash Display", sans-serif;
  font-size: 23px;
  font-style: normal;
  font-weight: 600;
  color: #000000;
}

.normalText{
  font-family: "Clash Display", sans-serif;
  font-size: 12px;
  font-weight: 500;
  font-style: normal;
  color: #000F56;
}

.secondPlace{
  left: 8%;
  top: 18%;
}

.firstPlace{
  left: 38%;
  top: 6%;
}

.thirdPlace{
  left: 67%;
  top: 18%;
}

.bold{
  color: #FFFFFF;
  font-family: "Clash Display", sans-serif;
  font-size: 12px;
  font-weight: 700;
}

.textNorm{
  color: #FFFFFF;
  font-family: "Clash Display", sans-serif;
  font-size: 12px;
  font-weight: 500;
}

.positionButton{
  background-color:#000000;
  border-radius: 24px;
  font-family: "Clash Display", sans-serif;
  font-weight: 600;
  color: #ffffff;
  font-size: 17px;
  bottom: 33%;

}

.players{
  bottom: 27%;
  left: 9%;
}

.playerRow{
  font-family: "Clash Display", sans-serif;
  font-weight: 400;
  font-size: 12px;
  color: #FFFFFF;
}

.scrollable-leaderboard {
  bottom: 5%;
  left: 9%;
  height: 97px;
  overflow-y: auto;
  padding-right: 5px;
}

.playerRowItem {
  margin-bottom: 8px;
}

.scrollable-leaderboard::-webkit-scrollbar {
  width: 6px;
}

.scrollable-leaderboard::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 10px;
}

.scrollable-leaderboard::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.3);
  border-radius: 10px;
}

.scrollable-leaderboard::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.5);
}
</style>